var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['z-line-item', _vm.vertical && 'vertical'],style:(_vm.newCssStyle)},[_c('div',{staticClass:"label",style:(_vm.newLabelStyle)},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"value",style:(_vm.newValueStyle)},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.value))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }